import { Button, Grid, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useState } from "react";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import { RealTimeTrendDialog } from "./TrandDialogue/RealTimeTrendDialog";
import { RealUsersTrendDialog } from "./TrandDialogue/RealUsersTrendDialog";
import { AdsMobileTrendDialog } from "./TrandDialogue/AdsMobileTrendDialog";
import { format } from "date-fns";
import { useSelector } from "react-redux";

const PerformanceDashboardOverallScoreTrend = () => {
  const {
    exequteQueryContent,
    exequteQueryCompareQuery,
    exequteQueryContentQuery4,
    exequteQueryCompareQuery4,
    exequteQueryContentQuery3,
    exequteQueryContentQuery6,
    exequteQueryContentQuery5,
    selectedPeriod,
    selectedPage,
  } = useSelector((state: any) => state.pageSpeedPerformance);
  const [openRealTime, setOpenRealTime] = useState(false);
  const [openRealUsers, setOpenRealUsers] = useState(false);
  const [openAdsMobile, setOpenAdsMobile] = useState(false);
  const RealTimePerformanceScore = parseFloat(
    (
      exequteQueryContent?.payload?.[0]?.real_time_performance_score * 100 || 0
    ).toFixed(2)
  );
  const PreviousRealTimePerformanceScore = parseFloat(
    (
      (exequteQueryCompareQuery?.payload?.[0]?.real_time_performance_score ||
        0) * 100
    ).toFixed(2)
  );
  const AdsMobilePageSpeedScore = parseFloat(
    (
      (exequteQueryContent?.payload?.[0]?.Ads_Mobile_Page_Speed_Score || 0) *
      100
    ).toFixed(2)
  );
  const PreviousAdsMobilePageSpeedScore = parseFloat(
    (
      (exequteQueryCompareQuery?.payload?.[0]?.Ads_Mobile_Page_Speed_Score ||
        0) * 100
    ).toFixed(2)
  );
  const RealUsersExperience = parseFloat(
    (
      (exequteQueryContent?.payload?.[0]?.real_Users_Experience || 0) * 100
    ).toFixed(2)
  );
  const PreviousRealUsersExperience = parseFloat(
    (
      (exequteQueryCompareQuery?.payload?.[0]?.real_Users_Experience || 0) * 100
    ).toFixed(2)
  );

  const PageSpecificRealTimePerformanceScore =
    exequteQueryContentQuery4?.payload
      ?.filter((item: any) => item.page_name === selectedPage?.page_name)
      ?.map((item: any) => item.real_time_performance_score * 100);

  const AverageRealTimePerformanceScore =
    PageSpecificRealTimePerformanceScore &&
    PageSpecificRealTimePerformanceScore.length > 0
      ? PageSpecificRealTimePerformanceScore.reduce(
          (acc: any, score: any) => acc + score,
          0
        ) / PageSpecificRealTimePerformanceScore?.length
      : 0; // Return 0 if there are no scores

  const PreviousPageSpecificRealTimeScores = exequteQueryCompareQuery4?.payload
    ?.filter((item: any) => item.page_name === selectedPage?.page_name)
    ?.map((item: any) => item.real_time_performance_score * 100);

  const AveragePreviousRealTimeScore =
    PreviousPageSpecificRealTimeScores &&
    PreviousPageSpecificRealTimeScores.length > 0
      ? PreviousPageSpecificRealTimeScores.reduce(
          (acc: any, score: any) => acc + score,
          0
        ) / PreviousPageSpecificRealTimeScores?.length
      : 0; // Return 0 if there are no scores

  const PageSpecificRealUsersExperience = exequteQueryContentQuery4?.payload
    ?.filter((item: any) => item.page_name === selectedPage?.page_name)
    ?.map((item: any) => item.Real_Users_Experience * 100);

  const AverageRealUsersExperience =
    PageSpecificRealUsersExperience &&
    PageSpecificRealUsersExperience.length > 0
      ? PageSpecificRealUsersExperience.reduce(
          (acc: any, score: any) => acc + score,
          0
        ) / PageSpecificRealUsersExperience?.length
      : 0; // Return 0 if there are no scores

  const PreviousPageSpecificRealUsersExperience =
    exequteQueryCompareQuery4?.payload
      ?.filter((item: any) => item.page_name === selectedPage?.page_name)
      ?.map((item: any) => item.Real_Users_Experience * 100);

  const AveragePreviousRealUsersExperience =
    PreviousPageSpecificRealUsersExperience &&
    PreviousPageSpecificRealUsersExperience.length > 0
      ? PreviousPageSpecificRealUsersExperience.reduce(
          (acc: any, score: any) => acc + score,
          0
        ) / PreviousPageSpecificRealUsersExperience?.length
      : 0; // Return 0 if there are no scores

  const PageSpecificAdsMobilePageSpeedScore = exequteQueryContentQuery4?.payload
    ?.filter((item: any) => item.page_name === selectedPage?.page_name)
    ?.map((item: any) => item.Ads_Mobile_Page_Speed_Score * 100);

  const AverageAdsMobilePageSpeedScore =
    PageSpecificAdsMobilePageSpeedScore &&
    PageSpecificAdsMobilePageSpeedScore.length > 0
      ? PageSpecificAdsMobilePageSpeedScore.reduce(
          (acc: any, score: any) => acc + score,
          0
        ) / PageSpecificAdsMobilePageSpeedScore?.length
      : 0; // Return 0 if there are no scores

  const PreviousPageSpecificAdsMobilePageSpeedScore =
    exequteQueryCompareQuery4?.payload
      ?.filter((item: any) => item.page_name === selectedPage?.page_name)
      ?.map((item: any) => item.Ads_Mobile_Page_Speed_Score * 100);

  const AveragePreviousAdsMobilePageSpeedScore =
    PreviousPageSpecificAdsMobilePageSpeedScore &&
    PreviousPageSpecificAdsMobilePageSpeedScore.length > 0
      ? PreviousPageSpecificAdsMobilePageSpeedScore.reduce(
          (acc: any, score: any) => acc + score,
          0
        ) / PreviousPageSpecificAdsMobilePageSpeedScore?.length
      : 0; // Return 0 if there are no scores

  // function to calculate the percentage changes
  const calculatePercentageChange = (
    currentScore: number,
    previousScore: number
  ): number => {
    return (currentScore / previousScore - 1) * 100;
  };

  const RealTimePercentageChange = calculatePercentageChange(
    RealTimePerformanceScore,
    PreviousRealTimePerformanceScore
  );
  const AdsMobilePercentageChange = calculatePercentageChange(
    AdsMobilePageSpeedScore,
    PreviousAdsMobilePageSpeedScore
  );
  const RealUsersPercentageChange = calculatePercentageChange(
    RealUsersExperience,
    PreviousRealUsersExperience
  );
  const PageSpecificRealTimePercentageChange = calculatePercentageChange(
    AverageRealTimePerformanceScore,
    AveragePreviousRealTimeScore
  );
  const PageSpecificRealUsersPercentageChange = calculatePercentageChange(
    AverageRealUsersExperience,
    AveragePreviousRealUsersExperience
  );
  const PageSpecificAdsMobilePercentageChange = calculatePercentageChange(
    AverageAdsMobilePageSpeedScore,
    AveragePreviousAdsMobilePageSpeedScore
  );

  const renderRealTImeTrendIcon = () => {
    if (RealTimePerformanceScore > PreviousRealTimePerformanceScore) {
      return <TrendingUpIcon />;
    } else if (RealTimePerformanceScore < PreviousRealTimePerformanceScore) {
      return <TrendingDownIcon />;
    } else if (RealTimePercentageChange === PreviousRealTimePerformanceScore) {
      return <TrendingFlatIcon />;
    }
  };

  const renderPageSpecificRealTimeTrendIcon = () => {
    if (AverageRealTimePerformanceScore > AveragePreviousRealTimeScore) {
      return <TrendingUpIcon />;
    } else if (AverageRealTimePerformanceScore < AveragePreviousRealTimeScore) {
      return <TrendingDownIcon />;
    } else if (
      PageSpecificRealTimePercentageChange === AveragePreviousRealTimeScore
    ) {
      return <TrendingFlatIcon />;
    }
  };

  const renderAdsMobileTrendIcon = () => {
    if (AdsMobilePageSpeedScore > PreviousAdsMobilePageSpeedScore) {
      return <TrendingUpIcon />;
    } else if (AdsMobilePageSpeedScore < PreviousAdsMobilePageSpeedScore) {
      return <TrendingDownIcon />;
    } else if (AdsMobilePercentageChange === PreviousAdsMobilePageSpeedScore) {
      return <TrendingFlatIcon />;
    }
  };

  const renderPageSpecificAdsMobileTrendIcon = () => {
    if (
      AverageAdsMobilePageSpeedScore > AveragePreviousAdsMobilePageSpeedScore
    ) {
      return <TrendingUpIcon />;
    } else if (
      AverageAdsMobilePageSpeedScore < AveragePreviousAdsMobilePageSpeedScore
    ) {
      return <TrendingDownIcon />;
    } else if (
      PageSpecificAdsMobilePercentageChange ===
      AveragePreviousAdsMobilePageSpeedScore
    ) {
      return <TrendingFlatIcon />;
    }
  };

  const renderRealUsersTrendIcon = () => {
    if (RealUsersExperience > PreviousRealUsersExperience) {
      return <TrendingUpIcon />;
    } else if (RealUsersExperience < PreviousRealUsersExperience) {
      return <TrendingDownIcon />;
    } else if (RealUsersPercentageChange === PreviousRealUsersExperience) {
      return <TrendingFlatIcon />;
    }
  };

  const renderPageSpecificRealUsersTrendIcon = () => {
    if (AverageRealUsersExperience > AveragePreviousRealUsersExperience) {
      return <TrendingUpIcon />;
    } else if (
      AverageRealUsersExperience < AveragePreviousRealUsersExperience
    ) {
      return <TrendingDownIcon />;
    } else if (
      PageSpecificRealUsersPercentageChange ===
      AveragePreviousRealUsersExperience
    ) {
      return <TrendingFlatIcon />;
    }
  };

  const GraphRealUsers = exequteQueryContentQuery3?.payload?.length
    ? exequteQueryContentQuery3?.payload?.map((item: any) => ({
        x: format(new Date(item?.DATE), "dd-MM-yyyy") || "No Date",
        y: parseFloat(((item?.Real_Users_Experience || 0) * 100).toFixed(2)),
      }))
    : [{ x: "No Data", y: 0 }];

  const GraphPageSpecificRealUsers = exequteQueryContentQuery4?.payload?.length
    ? exequteQueryContentQuery4?.payload
        ?.filter((item: any) => item.page_name === selectedPage?.page_name)
        ?.map((item: any) => ({
          x: format(new Date(item?.DATE), "dd-MM-yyyy") || "No Date",
          y: parseFloat(((item?.Real_Users_Experience || 0) * 100).toFixed(2)),
        }))
    : [{ x: "No Data", y: 0 }];

  const GraphRealTime = exequteQueryContentQuery3?.payload?.length
    ? exequteQueryContentQuery3?.payload?.map((item: any) => ({
        x: format(new Date(item?.DATE), "dd-MM-yyyy") || "No Date",
        y: parseFloat(
          ((item?.real_time_performance_score || 0) * 100).toFixed(2)
        ),
      }))
    : [{ x: "No Data", y: 0 }];

  const GraphPageSpecificRealTime = exequteQueryContentQuery4?.payload?.length
    ? exequteQueryContentQuery4?.payload
        ?.filter((item: any) => item.page_name === selectedPage?.page_name)
        ?.map((item: any) => ({
          x: format(new Date(item?.DATE), "dd-MM-yyyy") || "No Date",
          y: parseFloat(
            ((item?.real_time_performance_score || 0) * 100).toFixed(2)
          ),
        }))
    : [{ x: "No Data", y: 0 }];

  const GraphAdsMobile = exequteQueryContentQuery5?.payload?.length
    ? exequteQueryContentQuery5?.payload?.map((item: any) => ({
        x: format(new Date(item?.DATE), "dd-MM-yyyy") || "No Date",
        y: parseFloat(
          ((item?.Avg_Ads_Mobile_Page_Speed || 0) * 100).toFixed(2)
        ),
      }))
    : [{ x: "No Data", y: 0 }];

  const GraphAdsMobilePageSpecific =
    exequteQueryContentQuery6?.payload
      ?.filter((item: any) => item.page_name === selectedPage?.page_name)
      ?.map((item: any) => ({
        x: format(new Date(item?.DATE), "dd-MM-yyyy"), // Format the date
        y: parseFloat((item?.Avg_Ads_Mobile_Page_Speed || 0).toFixed(2)),
      })) || []; // Fallback to an empty array if data is unavailable

  const GraphAchievementMobile = exequteQueryContentQuery5?.payload?.length
    ? exequteQueryContentQuery5?.payload?.map((item: any) => ({
        x: format(new Date(item?.DATE), "dd-MM-yyyy") || "No Date",
        y: parseFloat(((item?.achievement_Mobile || 0) * 100).toFixed(2)),
      }))
    : [{ x: "No Data", y: 0 }];

  const GraphAchievementMobilePageSpecific =
    exequteQueryContentQuery6?.payload
      ?.filter((item: any) => item.page_name === selectedPage?.page_name)
      ?.map((item: any) => ({
        x: format(new Date(item?.DATE), "dd-MM-yyyy"), // Format the date
        y: parseFloat((item?.achievement_Mobile || 0).toFixed(2)),
      })) || []; // Fallback to an empty array if data is unavailable

  const GraphMobileTarget = exequteQueryContentQuery5?.payload?.length
    ? exequteQueryContentQuery5?.payload?.map((item: any) => ({
        x: format(new Date(item?.DATE), "dd-MM-yyyy") || "No Date",
        y: parseFloat(((item?.mobile_target || 0) * 100).toFixed(2)),
      }))
    : [{ x: "No Data", y: 0 }];

  const GraphMobileTargetPageSpecific =
    exequteQueryContentQuery6?.payload
      ?.filter((item: any) => item.page_name === selectedPage?.page_name)
      ?.map((item: any) => ({
        x: format(new Date(item?.DATE), "dd-MM-yyyy"), // Format the date
        y: parseFloat((item?.mobile_target || 0).toFixed(2)),
      })) || []; // Fallback to an empty array if data is unavailable

  const handleRealTimeOpen = () => {
    setOpenRealTime(true);
  };

  const handleCloseRealTime = () => {
    setOpenRealTime(false);
  };

  const handleRealUsersOpen = () => {
    setOpenRealUsers(true);
  };

  const handleCloseRealUsers = () => {
    setOpenRealUsers(false);
  };

  const handleAdsMobileOpen = () => {
    setOpenAdsMobile(true);
  };

  const handleCloseAdsMobile = () => {
    setOpenAdsMobile(false);
  };
  const getColor = (score: any) => {
    if (score <= 85) return { background: "#FDEDED", border: "#D32F2F80" }; // Red
    if (score <= 95) return { background: "#FFF4E5", border: "#ED6C0280" }; // Yellow/Orange
    return { background: "#EDF7ED", border: "#2E7D3280" }; // Green
  };
  const getButtonColor = (score: any) => {
    if (score <= 85) return "error"; // Red
    if (score <= 95) return "warning"; // Yellow/Orange
    return "success"; // Green
  };
  // Use this function to calculate the styles for each card
  const realUsersColor = getColor(
    selectedPage ? AverageRealUsersExperience : RealUsersExperience
  );
  const adsMobileColor = getColor(
    selectedPage ? AverageAdsMobilePageSpeedScore : AdsMobilePageSpeedScore
  );
  const realTimeColor = getColor(
    selectedPage ? AverageRealTimePerformanceScore : RealTimePerformanceScore
  );
  // Use this function to calculate the styles for each card

  return (
    <>
      <Box
        className="trendWrap"
        sx={{
          background: realUsersColor.background,
          border: `1px solid ${realUsersColor.border}`,
          minHeight: "125px",
        }}
      >
        <Stack
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: "row",
          }}
        >
          <Typography sx={{ fontWeight: "500", fontSize: "14px" }}>
            Real Users’ Experience
          </Typography>
          <Button
            data-tracker="157"
            size="small"
            sx={{
              width: "90px",
              fontSize: "10px",
              textTransform: "capitalize",
              padding: "0",
              borderColor: selectedPage
                ? getButtonColor(AverageRealUsersExperience)
                : getButtonColor(RealUsersExperience),
              color: selectedPage
                ? getButtonColor(AverageRealUsersExperience)
                : getButtonColor(RealUsersExperience),
            }}
            onClick={handleRealUsersOpen}
            variant="outlined"
            color={
              selectedPage
                ? getButtonColor(AverageRealUsersExperience)
                : getButtonColor(RealUsersExperience)
            }
          >
            view trend <LeaderboardIcon sx={{ width: "16px", ml: "5px" }} />
          </Button>
        </Stack>
        <Grid container spacing={4} alignItems={"center"}>
          <Grid item xs={3}>
            <Typography variant="h4" sx={{ fontWeight: "500" }}>
              {selectedPage
                ? Math?.floor(AverageRealUsersExperience)
                : RealUsersExperience}
              %
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  whiteSpace: "nowrap",
                  alignItems: "center",
                  display: "flex",
                  mr: "6px",
                }}
              >
                {selectedPage ? (
                  <>
                    {isNaN(PageSpecificRealUsersPercentageChange) ||
                    !isFinite(PageSpecificRealUsersPercentageChange)
                      ? "0%"
                      : PageSpecificRealUsersPercentageChange.toFixed(2) + "%"}
                    {renderPageSpecificRealUsersTrendIcon()}
                  </>
                ) : (
                  <>
                    {isNaN(RealUsersPercentageChange) ||
                    !isFinite(RealUsersPercentageChange)
                      ? "0%"
                      : RealUsersPercentageChange.toFixed(2) + "%"}
                    {renderRealTImeTrendIcon()}
                  </>
                )}
              </Typography>
              <Typography
                sx={{
                  color: "#000000",
                  fontSize: "9px",
                  fontWeight: "500",
                  paddingRight: "5px",
                }}
              >
                compared to the previous {selectedPeriod.toLowerCase()}.{" "}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={7}>
            <Typography
              variant="body1"
              sx={{
                color: "#00000099",
                fontSize: "10px",
                marginLeft: "37px",
                paddingRight: "2px",
              }}
            >
              The weighted average of achievement ratios, with each sub-metric
              multiplied by its weight.
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box
        className="trendWrap"
        my={2}
        sx={{
          background: adsMobileColor.background,
          border: `1px solid ${adsMobileColor.border}`,
          minHeight: "125px",
        }}
      >
        <Stack
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: "row",
          }}
        >
          <Typography sx={{ fontWeight: "500", fontSize: "14px" }}>
            Ads Mobile Page Speed Score
          </Typography>
          <Button
            data-tracker="157"
            size="small"
            sx={{
              width: "90px",
              fontSize: "10px",
              textTransform: "capitalize",
              padding: "0",
              borderColor: selectedPage
                ? getButtonColor(AverageAdsMobilePageSpeedScore)
                : getButtonColor(AdsMobilePageSpeedScore),
              color: selectedPage
                ? getButtonColor(AverageAdsMobilePageSpeedScore)
                : getButtonColor(AdsMobilePageSpeedScore),
            }}
            variant="outlined"
            color={
              selectedPage
                ? getButtonColor(AverageAdsMobilePageSpeedScore)
                : getButtonColor(AdsMobilePageSpeedScore)
            }
            onClick={handleAdsMobileOpen}
          >
            view trend <LeaderboardIcon sx={{ width: "16px", ml: "5px" }} />
          </Button>
        </Stack>
        <Grid container spacing={5} alignItems={"center"}>
          <Grid item xs={3}>
            <Typography variant="h4" sx={{ fontWeight: "500" }}>
              {selectedPage
                ? Math?.floor(AverageAdsMobilePageSpeedScore)
                : AdsMobilePageSpeedScore}
              %
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  whiteSpace: "nowrap",
                  alignItems: "center",
                  display: "flex",
                  mr: "6px",
                }}
              >
                {selectedPage ? (
                  <>
                    {isNaN(PageSpecificAdsMobilePercentageChange) ||
                    !isFinite(PageSpecificAdsMobilePercentageChange)
                      ? "0%"
                      : PageSpecificAdsMobilePercentageChange.toFixed(2) + "%"}
                    {renderPageSpecificAdsMobileTrendIcon()}
                  </>
                ) : (
                  <>
                    {isNaN(AdsMobilePercentageChange) ||
                    !isFinite(AdsMobilePercentageChange)
                      ? "0%"
                      : AdsMobilePercentageChange.toFixed(2) + "%"}
                    {renderAdsMobileTrendIcon()}
                  </>
                )}
              </Typography>
              <Typography
                sx={{
                  color: "#000000",
                  fontSize: "9px",
                  fontWeight: "500",
                  paddingRight: "5px",
                }}
              >
                compared to the previous {selectedPeriod.toLowerCase()}.{" "}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={7}>
            <Typography
              variant="body1"
              sx={{
                color: "#00000099",
                fontSize: "10px",
                marginLeft: "37px",
                paddingRight: "2px",
              }}
            >
              The weighted average of achievement ratios, with each sub-metric
              multiplied by its weight.
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box
        className="trendWrap"
        sx={{
          background: realTimeColor.background,
          border: `1px solid ${realTimeColor.border}`,
          minHeight: "125px",
        }}
      >
        <Stack
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: "row",
          }}
        >
          <Typography sx={{ fontWeight: "500", fontSize: "14px" }}>
            Real Time Performance Score
          </Typography>
          <Button
            data-tracker="157"
            size="small"
            sx={{
              width: "90px",
              fontSize: "10px",
              textTransform: "capitalize",
              padding: "0",
              borderColor: selectedPage
                ? getButtonColor(AverageRealTimePerformanceScore)
                : getButtonColor(RealTimePerformanceScore),
              color: selectedPage
                ? getButtonColor(AverageRealTimePerformanceScore)
                : getButtonColor(RealTimePerformanceScore),
            }}
            variant="outlined"
            color={
              selectedPage
                ? getButtonColor(AverageRealTimePerformanceScore)
                : getButtonColor(RealTimePerformanceScore)
            }
            onClick={handleRealTimeOpen}
          >
            view trend <LeaderboardIcon sx={{ width: "16px", ml: "5px" }} />
          </Button>
        </Stack>
        <Grid container spacing={5} alignItems={"center"}>
          <Grid item xs={3}>
            <Typography variant="h4" sx={{ fontWeight: "500" }}>
              {selectedPage
                ? Math.floor(AverageRealTimePerformanceScore)
                : RealTimePerformanceScore}
              %
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  whiteSpace: "nowrap",
                  alignItems: "center",
                  display: "flex",
                  mr: "6px",
                }}
              >
                {selectedPage ? (
                  <>
                    {isNaN(PageSpecificRealTimePercentageChange) ||
                    !isFinite(PageSpecificRealTimePercentageChange)
                      ? "0%"
                      : PageSpecificRealTimePercentageChange.toFixed(2) + "%"}
                    {renderPageSpecificRealTimeTrendIcon()}
                  </>
                ) : (
                  <>
                    {isNaN(RealTimePercentageChange) ||
                    !isFinite(RealTimePercentageChange)
                      ? "0%"
                      : RealTimePercentageChange.toFixed(2) + "%"}
                    {renderRealUsersTrendIcon()}
                  </>
                )}
              </Typography>
              <Typography
                sx={{
                  color: "#000000",
                  fontSize: "9px",
                  fontWeight: "500",
                  paddingRight: "5px",
                }}
              >
                compared to the previous {selectedPeriod.toLowerCase()}.{" "}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={7}>
            <Typography
              variant="body1"
              sx={{
                color: "#00000099",
                fontSize: "10px",
                marginLeft: "37px",
                paddingRight: "2px",
              }}
            >
              The weighted average of achievement ratios, with each sub-metric
              multiplied by its weight.
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <RealTimeTrendDialog
        openRealTime={openRealTime}
        GraphRealTime={GraphRealTime}
        GraphPageSpecificRealTime={GraphPageSpecificRealTime}
        onCloseRealTime={handleCloseRealTime}
      />
      <AdsMobileTrendDialog
        openAdsMobile={openAdsMobile}
        GraphAdsMobile={GraphAdsMobile}
        GraphAchievementMobile={GraphAchievementMobile}
        GraphMobileTarget={GraphMobileTarget}
        GraphAdsMobilePageSpecific={GraphAdsMobilePageSpecific}
        GraphAchievementMobilePageSpecific={GraphAchievementMobilePageSpecific}
        GraphMobileTargetPageSpecific={GraphMobileTargetPageSpecific}
        onCloseAdsMobile={handleCloseAdsMobile}
      />
      <RealUsersTrendDialog
        openRealUsers={openRealUsers}
        GraphRealUsers={GraphRealUsers}
        GraphPageSpecificRealUsers={GraphPageSpecificRealUsers}
        onCloseRealUsers={handleCloseRealUsers}
      />
    </>
  );
};

export default PerformanceDashboardOverallScoreTrend;
